export const ActiveStatus = {
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED',
};

export const ActiveStatusLabel = {
  [ActiveStatus.ACTIVE]: 'Active',
  [ActiveStatus.ARCHIVED]: 'Archived',
};
